import { useTranslation } from "next-i18next";
import { useRecoilState } from "recoil";

import { ConfirmModal } from "design_system/components/Modal";
import { isCancelModalRemovingState, modalCancelingItemState } from "src/states";

type Props = {
  onConfirmClick: (cartItem: any) => void;
};

const RemoveCartItemModal = ({ onConfirmClick }: Props) => {
  const { t } = useTranslation("checkout");

  const [modalCancelingItem, setModalCancelingItem] = useRecoilState(modalCancelingItemState);
  const [isRemoving] = useRecoilState(isCancelModalRemovingState);

  const transPath = "modal.remove-cart-item";

  return (
    <ConfirmModal
      body={t(`${transPath}.title`)}
      confirmText={t(`${transPath}.button.confirm`)}
      cancelText={t(`${transPath}.button.cancel`)}
      isOpen={!!modalCancelingItem}
      onClose={() => setModalCancelingItem(null)}
      onConfirmClick={() => onConfirmClick(modalCancelingItem)}
      isLoading={isRemoving}
    />
  );
};

export default RemoveCartItemModal;
